export function matchesEmployeeSearch(employee, query) {
  if (!query) return true;
  const q = query.toLowerCase();
  const name = employee.name || '';
  const employeeId = employee.employeeId || '';
  const department = employee.department || '';
  return name.toLowerCase().includes(q)
    || employeeId.toLowerCase().includes(q)
    || department.toLowerCase().includes(q);
}
